// 用于存储CRF表
import { defineStore } from "pinia";
import { useCommonStore } from "@/stores/common";
import drugDB from "@/assets/drugDB.json";

const env = import.meta.env;

export const useCrfStore = defineStore("crf", {
  state: () => ({
    forms: [
      {
        name: "入选标准",
        type: "入选标准",
        module: ["YBXX", "InclusionCriteria",]
      },
      {
        name: "排除标准",
        type: "排除标准",
        module: ["YBXX", "ExcludeCriteria",]
      },
      {
        // name: "筛选期（肝穿前96周内资料完整点）±2周",
        name: "筛选期（96周内最靠前资料完整点）±2周",
        // type: "V1筛选期（肝穿前96周内）",
        type: "筛选期（肝穿前96周内资料完整点）±2周",
        module: ["YBXX", "FSXX", "BS", "QTBSZL", "JWTIPSZL", "JWWKSSZL","MYQDB", "JWNJZL", "JWYWZL","GZSDC", "YJQJDYWZL", "YJQJDTIPSZL", "YJQJDNJZL", "YJQJDWKZL", "XCGJNCG", "NXGN", "FBCT","XSHJC", "AFP", "YGHCVHIV", "ANAANCA", "JZXGN", "XDT", "WJ", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "MJMCTV", "GZZQCT","GZZQMR", "MRCP", "HVPGCD",]
      },
      {//0
        name: "V0肝穿点±2周",
        // type: "V2基线访视（肝穿后）",
        type: "V0肝穿点±2周",
        module: ["YBXX", "FSXX", "TGJC", "QTBSZL","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","GZSDC", "YJQJDYWZL", "YJQJDTIPSZL", "YJQJDNJZL", "YJQJDWKZL", "XCGJNCG", "NXGN", "XSHJC","MRCP", "AFP", "YGHCVHIV", "ANAANCA", "JZXGN","MYQDB","XDT", "WJ", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "HVPGCD", "FBCT","MJMCTV", "GZZQMR","QWXZJYCX", "GZZQCT","BFXY","BLBG"],
        moduleOld: ["YBXX", "FSXX", "TGJC", "QTBSZL","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","GZSDC", "YJQJDYWZL", "YJQJDTIPSZL", "YJQJDNJZL", "YJQJDWKZL", "XCGJNCG", "NXGN", "XSHJC","MRCP", "AFP", "YGHCVHIV", "ANAANCA", "JZXGN","MYQDB","XDT", "WJ", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "HVPGCD", "FBCT","MJMCTV", "GZZQMR","QWXZJYCX", "GZZQCT","BFXY","BLBG"]
      },
      {//1
        name: "访视期V1（肝穿后24周）",
        type: "访视期V1（肝穿后24周）",
        tip:24,
        module: ["YBXX", "FSXX",  "XCGJNCG","HVPGCD", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","AFP","NXGN", "MJMCTV", "XSHJC","FIBROSCAN","FIBROTOUCH", "XDT","WJ", "FBFSMJMBC","BLSJJL" ,"MRCP","GZZQMR","FBCT","GZZQCT","MYQDB",]
      },
       {//2
        name: "访视期V2（肝穿后48周）",
        type: "访视期V2（肝穿后48周）",
        tip:48,
        module: ["YBXX", "FSXX",  "ANAANCA","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV", "TGJC","XDT", "WJ","HVPGCD", "FBFSMJMBC","AFP", "XCGJNCG", "MRCP","MJMCTV", "NXGN","FIBROSCAN","FIBROTOUCH",  "FBCT","XSHJC","GZZQMR","BLSJJL","GZZQCT",]
      },
      {//3
        name: "访视期V3（肝穿后72周）",
        type: "访视期V3（肝穿后72周）",
        tip:72,
        module: ["YBXX", "FSXX", "XCGJNCG", "MYQDB","NXGN","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","XSHJC", "AFP","XDT","WJ","HVPGCD","MJMCTV","FIBROSCAN","FIBROTOUCH", "MRCP","FBFSMJMBC", "GZZQMR", "FBCT","BLSJJL","GZZQCT",]
      },
       {//4
        name: "访视期V4（肝穿后96周）",
        type: "访视期V4（肝穿后96周）",
        tip:96,
        module: ["YBXX", "FSXX", "TGJC","XCGJNCG","BS","MYQDB","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV","XDT", "WJ", "HVPGCD","ANAANCA", "NXGN", "XSHJC", "MRCP", "MJMCTV","AFP", "FBCT", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC","GZZQMR", "BLSJJL","GZZQCT",]
      },
      {//5
        name: "访视期V5（肝穿后120周）",
        type: "访视期V5（肝穿后120周）",
        tip:120,
        module: ["YBXX", "FSXX",  "XCGJNCG","MYQDB", "NXGN","BS", "XSHJC","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","XDT", "WJ","AFP","HVPGCD","MJMCTV", "FIBROSCAN","FIBROTOUCH","MRCP", "GZZQMR","FBFSMJMBC",  "FBCT","BLSJJL","GZZQCT",]
      },
      {//6
        name: "访视期V6（肝穿后144周）",
        type: "访视期V6（肝穿后144周）",
        tip:144,
        module: ["YBXX", "FSXX", "TGJC", "XCGJNCG","MYQDB","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV", "NXGN", "MJMCTV", "XSHJC","HVPGCD","AFP", "ANAANCA","XDT","WJ", "MRCP","FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "FBCT","GZZQMR", "BLSJJL","GZZQCT",]
      },
      {//7
        name: "访视期V7（肝穿后168周）",
        type: "访视期V7（肝穿后168周）",
        tip:168,
        module: ["YBXX", "FSXX", "XCGJNCG","MYQDB", "XDT", "WJ", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","AFP","NXGN", "XSHJC", "MJMCTV", "HVPGCD","FIBROSCAN","FIBROTOUCH","GZZQMR","MRCP", "FBFSMJMBC", "FBCT", "BLSJJL","GZZQCT",]
      },
       {//8
        name: "访视期V8（肝穿后192周）",
        type: "访视期V8（肝穿后192周）",
        tip:192,
        module: ["YBXX", "FSXX","TGJC", "AFP", "XCGJNCG","BS","MYQDB", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV","NXGN", "XDT", "HVPGCD","WJ", "ANAANCA","XSHJC", "MRCP", "MJMCTV","FIBROSCAN","FIBROTOUCH", "GZZQMR","FBFSMJMBC", "FBCT","BLSJJL","GZZQCT",]
      },
      {//9
        name: "访视期V9（肝穿后216周）",
        type: "访视期V9（肝穿后216周）",
        tip:216,
        module: ["YBXX", "FSXX", "XCGJNCG","MYQDB", "NXGN", "XSHJC","BS", "XDT","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL", "WJ","AFP", "MJMCTV","HVPGCD","FIBROSCAN","FIBROTOUCH", "MRCP","GZZQMR","FBFSMJMBC",  "FBCT","BLSJJL","GZZQCT",]
      },
       {//10
        name: "访视期V10（肝穿后240周）",
        type: "访视期V10（肝穿后240周）",
        tip:240,
        module: ["YBXX", "FSXX","TGJC", "XCGJNCG", "NXGN","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL", "YGHCVHIV", "XSHJC", "HVPGCD","AFP", "ANAANCA", "XDT", "WJ", "MRCP","FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "FBCT", "MJMCTV", "GZZQMR", "BLSJJL","GZZQCT",]
      },
    
    ],
    // 计划外访视
    planoutside: {
      name: "访视期V10（肝穿后240周）",
      type: "访视期V10（肝穿后240周）",
      tip:240,
      module: ["YBXX", "FSXX",  "XCGJNCG","HVPGCD","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","AFP","NXGN", "MJMCTV", "XSHJC","FIBROSCAN","FIBROTOUCH", "XDT","WJ", "FBFSMJMBC","BLSJJL" ,"MRCP","GZZQMR","FBCT","GZZQCT",],
      //["YBXX", "FSXX","TGJC", "XCGJNCG", "NXGN","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL", "YGHCVHIV", "XSHJC", "HVPGCD","AFP", "ANAANCA", "XDT", "WJ", "MRCP","FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "FBCT", "MJMCTV", "GZZQMR", "BLSJJL"]
    
    },
    modules: {
      InclusionCriteria: "入选标准",
      ExcludeCriteria: "排除标准",
      YBXX: "一般信息",
      FSXX: "访视信息",
      BS: "病史",
      TGJC: "体格检查",
      QTBSZL: "其他伴随治疗",
      JWTIPSZL: "既往TIPS治疗",
      JWWKSSZL: "既往外科手术治疗",
      JWNJZL: "既往内镜治疗",
      JWYWZL: "既往药物治疗",
      YJQJDYWZL: "研究期间的药物治疗",
      YJQJDTIPSZL: "研究期间的TIPS治疗",
      YJQJDNJZL: "研究期间的内镜治疗",
      YJQJDWKZL: "研究期间的外科治疗",
      XCGJNCG: "血常规及尿常规",
      NXGN: "凝血功能",
      XSHJC: "血生化检查",
      AFP: "AFP",
      YGHCVHIV: "乙肝两对半检查、抗HCV、抗HIV",
      ANAANCA: "ANA、ENA抗体谱、ANCA、自身免疫性肝病抗体谱",
      MYQDB: "免疫球蛋白[IgG,IgA,IgM,IgE,IgG4(可选)]",
      JZXGN: "甲状腺功能（可选）",
      XDT: "心电图（可选）",
      WJ: "胃镜",
      FIBROSCAN:"FIBROSCAN",
      FIBROTOUCH: "FIBROTOUCH",
      FBFSMJMBC: "腹部、腹水及门静脉B超",
      FBCT: "肺部CT平扫（可选）",
      MJMCTV: "门静脉CTV",
      GZZQMR: "肝脏增强MR",
      MRCP: "MRCP（可选）",
      HVPGCD: "HVPG测定（可选）",
      BFXY: "备份血样（可选）",
      GZZQCT:"肝脏增强ct",
      BLSJJL:"不良事件记录",
      BLBG:"病理报告"
    },
    textRules: function(label, required = false, options = null) {
      let rules = [
        {
          required: required,
          message: "请输入" + label,
          trigger: "change",
          label: label
        }
      ];
      if (options != null) {
        rules.push(options);
      }
      return rules;
    },
    // 数字的规则
    intNumberRules: function(label, required = false) {
      return [
        {
          required: required,
          validator: function(rule, value, callback) {
            let regex = /^\d+$/;
            // 必填，且值为空时
            if (required && (!value || value === "")) {
              callback(new Error(`请输入${rule.label}`));
            }
            // 值不为空时，且值不是数字时
            if (value && value !== "" && !regex.test(value)) {
              console.log("请输入数字", value);
              callback(new Error("请输入数字"));
            } else {
              callback();
            }
          },
          trigger: "change",
          label: label
        }
      ];
    },
    // 输入框不为空
    inputNotNull:function(label){
      return [
        {
          required: true,
          validator: function(rule, value, callback) {
            // let regex = /^\d+(\.\d+)?$/;
            // 必填，且值为空时
            if (required && (!value || value === "")) {
              callback(new Error(`请输入${rule.label}`));
            } else {
              callback();
            }
          },
          trigger: "change",
          label: label
        }
      ];
    },
    // 浮点数的规则
    floatNumberRules: function(label, required = false) {
      return [
        {
          required: required,
          validator: function(rule, value, callback) {
            let regex = /^\d+(\.\d+)?$/;
            // 必填，且值为空时
            if (required && (!value || value === "")) {
              callback(new Error(`请输入${rule.label}`));
            }
            // 值不为空时，且值不是数字时
            if (value && value !== "" && !regex.test(value)) {
              console.log("请输入数字", value);
              callback(new Error("请输入数字"));
            } else {
              callback();
            }
          },
          trigger: "change",
          label: label
        }
      ];
    },
    // Radio 必选的规则
    radioRules: function(label) {
      return [
        {
          required: true,
          trigger: "change",
          validator: function(rule, value, callback) {
            // console.log("radioRules", value);
            if (!value || value === "") {
              callback(new Error(`请选择${rule.label}`));
            } else {
              callback();
            }
          },
          label: label
        }
      ];
    },
    // 身份证后六位验证
    身份证后六位:[
      {
       async validator(rule, value, callback) {
          let re1 = /^[0-9]{5}[0-9X]$/
          // console.log(re1.test(value))
          if(value && re1.test(value) && (value.length == 6) ){
            if(value){
              let common = await useCommonStore().getIDcard("",value)
              if(common.data?.isExists){
                callback(new Error(`身份证后6位已存在`));
              }
              callback()
            }
          }else{
            callback(new Error('请输入正确的身份证后六位（前5位为数字，最后一位为数字或X）'));
          }
       
        }
      }
    ],
    // 患者姓名
    患者姓名:[
        {
          required: true,
          message: "请输入患者姓名",
          // trigger:'blur'
        }
    ],
    // 选择性别
    性别:[
      {
        required: true,
        message: "请选择性别",
        trigger:'change',
      } 
    ],
    生日:[
      {
        // type:'date', 看情况给不给，注意有没有设置时间的的格式“YY-MM-DD'
        required: true,
        message: "请选择出生日期",
        // trigger:'blur',
        trigger:'change',

      }
    ],
    主诊医生姓名:[
      {
          required: true,
          message: "请输入主诊医生姓名",
          trigger:'change',
          // validator(e,val,ea){
          //   console.log(val)
          // } 
      }
    ],
    // Checkbox 必选的规则
    checkboxRules: function(label) {
      return [
        {
          required: true,
          trigger: "change",
          validator: function(rule, value, callback) {
            if (!value || value.length === 0) {
              callback(new Error(`请选择${rule.label}`));
            } else {
              callback();
            }
          },
          label: label
        }
      ];
    },
    // 日期的规则
    dateRules: function(label, required = false) {
      return [
        {
          required: required,
          trigger: "change",
          validator: function(rule, value, callback) {
            if (!value || value === "") {
              callback(new Error(`请选择${rule.label}`));
            } else {
              callback();
            }
          },
          label: label
        }
      ];
    }
  }),
  actions: {
    // 更新数据
    update: (data) => {
      return new Promise(function(resolve, reject) {
        const commonStore = useCommonStore();
        let res = commonStore.updateData(data);
        resolve(res);
      });
    }
  }
});
